<template>
  <main class="main page-inside categories-page">
    <div class="main-wrapper">
      <section class="section hero-section categories-hero">
        <div class="wrapper">
          <div class="wrapper-top">
            <div class="title-container">
              <button
                type="button"
                class="back-page"
                :aria-label="$t('Назад')"
                @click="$parent.back"
              >
                <img class="back-img" src="./../img/back-page.svg" alt="" />
              </button>

              <h1 class="back-title">
                {{ $t('Лавка BloxNest') }}
              </h1>
            </div>

            <div class="tip">
              <div class="icon">
                <img src="./../img/gem.svg" class="icon-img" alt="" />
              </div>

              <div class="desc medium">
                {{ $t('Выберите категорию, чтобы посмотреть товары') }}
              </div>
            </div>
          </div>

          <div v-if="hasCategories" class="categories-navigation">
            <div class="categories-navigation__list">
              <button
                v-for="category in categories"
                :key="getCategoryKey(category)"
                type="button"
                class="categories-navigation__button"
                @click="chooseCategory(category)"
              >
                {{ $t(category.title) }}
              </button>
            </div>
          </div>
        </div>
      </section>

      <section class="section categories-section">
        <div class="wrapper">
          <div class="categories-section__header">
            <div>
              <h2 class="categories-section__title">
                {{ $t('Категории') }}
              </h2>

              <p class="categories-section__description">
                {{
                  $t('Выберите подходящий раздел и найдите нужные предметы.')
                }}
              </p>
            </div>

            <span v-if="hasCategories" class="categories-section__count">
              {{ categoriesLabel }}
            </span>
          </div>

          <transition name="fade" mode="out-in">
            <div v-if="hasCategories" key="categories" class="categories-grid">
              <article
                v-for="category in categories"
                :key="getCategoryKey(category)"
                class="category-card"
                @click="chooseCategory(category)"
              >
                <div class="category-card__preview">
                  <img
                    v-if="getCategoryImage(category)"
                    :src="getCategoryImage(category)"
                    :alt="category.title"
                    class="category-card__image"
                  />

                  <div
                    v-else
                    class="category-card__placeholder"
                    aria-hidden="true"
                  >
                    <svg
                      viewBox="0 0 48 48"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8 12H20L24 17H40V38H8V12Z"
                        stroke="currentColor"
                        stroke-width="3"
                        stroke-linejoin="round"
                      />

                      <path
                        d="M8 19H40"
                        stroke="currentColor"
                        stroke-width="3"
                      />
                    </svg>
                  </div>

                  <div class="category-card__overlay"></div>

                  <span class="category-card__badge">
                    {{ $t('КАТЕГОРИЯ') }}
                  </span>
                </div>

                <div class="category-card__content">
                  <div class="category-card__text">
                    <h3 class="category-card__title">
                      {{ $t(category.title) }}
                    </h3>

                    <p class="category-card__description">
                      {{
                        category.description ||
                        $t('Посмотреть доступные товары')
                      }}
                    </p>
                  </div>

                  <button
                    type="button"
                    class="button shadowed category-card__button"
                    @click.stop="chooseCategory(category)"
                  >
                    <span>{{ $t('СМОТРЕТЬ ТОВАРЫ') }}</span>

                    <svg
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                    >
                      <path
                        d="M3 7.5H12"
                        stroke="currentColor"
                        stroke-width="1.8"
                        stroke-linecap="round"
                      />

                      <path
                        d="M8.5 4L12 7.5L8.5 11"
                        stroke="currentColor"
                        stroke-width="1.8"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>
                </div>
              </article>
            </div>

            <div v-else key="empty" class="categories-empty">
              <div class="categories-empty__icon">
                <svg
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 12H19L24 17H41V39H7V12Z"
                    stroke="currentColor"
                    stroke-width="3"
                    stroke-linejoin="round"
                  />

                  <path d="M7 20H41" stroke="currentColor" stroke-width="3" />
                </svg>
              </div>

              <h3 class="categories-empty__title">
                {{ $t('Категории не найдены') }}
              </h3>

              <p class="categories-empty__description">
                {{
                  $t(
                    'В данный момент доступных категорий нет. Попробуйте зайти позже.',
                  )
                }}
              </p>
            </div>
          </transition>
        </div>
      </section>
    </div>
  </main>
</template>

<script>
export default {
  name: 'Categories',

  emits: ['chooseCategoty'],

  data() {
    return {
      imgDomain: '',
    }
  },

  computed: {
    categories() {
      const apiCategories = Array.isArray(this.$parent.categories)
        ? this.$parent.categories
        : []

      const packsCategory = {
        id: 'packs',
        title: 'Наборы',
        description: 'Готовые наборы предметов',
        url: '/packs',
        image_url: require('@/img/packs.png'),
        isPacks: true,
      }

      return [packsCategory, ...apiCategories]
    },
    hasCategories() {
      return this.categories.length > 0
    },

    categoriesLabel() {
      const count = this.categories.length

      if (count % 10 === 1 && count % 100 !== 11) {
        return `${count} категория`
      }

      if (
        count % 10 >= 2 &&
        count % 10 <= 4 &&
        (count % 100 < 12 || count % 100 > 14)
      ) {
        return `${count} категории`
      }

      return `${count} категорий`
    },
  },

  mounted() {
    this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN || ''
  },

  methods: {
    chooseCategory(category) {
      if (category.isPacks) {
        this.$router.push('/products/packs')
        return
      }

      this.$emit('chooseCategoty', category)
    },

    getCategoryKey(category) {
      return category.id || category.slug || category.url || category.title
    },

    getCategoryImage(category) {
      if (!category) {
        return ''
      }

      // Local custom category image
      if (category.isPacks) {
        return category.image_url
      }

      const imageUrl =
        category.image_url || category.img_url || category.image || ''

      if (!imageUrl) {
        return ''
      }

      if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://')) {
        return imageUrl
      }

      const domain = this.imgDomain.replace(/\/+$/, '')
      const path = imageUrl.replace(/^\/+/, '')

      return domain ? `${domain}/${path}` : `/${path}`
    },
  },
}
</script>

<style scoped lang="scss">
.categories-page {
  min-height: 50vh;
  background: var(--white-woodsmoke);
}

/* Hero */

.categories-hero {
  padding: 44px 16px 24px;
}

.categories-hero .wrapper-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}

.categories-hero .title-container {
  display: flex;
  align-items: center;
  gap: 16px;
}

.back-title {
  margin: 0;

  font-family: var(--font-2);
  font-size: 34px;
  font-weight: 700;
  line-height: 44px;

  color: var(--gray-nurse);
}

/* Hero category navigation */

.categories-navigation {
  margin-top: 26px;
  padding-bottom: 22px;
  border-bottom: 1px solid var(--outer-space);
}

.categories-navigation__list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.categories-navigation__button {
  position: relative;
  z-index: 1;

  display: flex;
  align-items: center;
  justify-content: center;

  min-height: 43px;
  padding: 11px 20px;

  font-family: var(--font-1);
  font-size: 14px;
  font-weight: 700;
  line-height: 19px;

  color: var(--edward);
  background: var(--heavy-metal);
  border: 1px solid var(--outer-space);
  border-radius: 11px;

  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    z-index: -1;

    background: linear-gradient(142deg, var(--44) 0%, var(--31) 100%);

    opacity: 0;
    transition: opacity 0.25s ease;
  }

  @media (any-hover: hover) {
    &:hover {
      color: var(--racing-green);
      border-color: transparent;
      transform: translateY(-1px);

      &::before {
        opacity: 1;
      }
    }
  }
}

/* Main section */

.categories-section {
  padding: 0px 16px 100px;

  .wrapper {
    max-width: 1210px;
    padding: 0px 16px 0;
  }
}

.categories-section__header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 26px;
}

.categories-section__eyebrow {
  margin: 0 0 8px;

  font-family: var(--font-3);
  font-size: 9px;
  font-weight: 700;
  line-height: 14px;
  letter-spacing: 0.08em;

  color: var(--44);
}

.categories-section__title {
  margin: 0;

  font-family: var(--font-2);
  font-size: 26px;
  font-weight: 700;
  line-height: 34px;

  color: var(--gray-nurse);
}

.categories-section__description {
  max-width: 560px;
  margin: 8px 0 0;

  font-family: var(--font-1);
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;

  color: var(--pewter);
}

.categories-section__count {
  flex: 0 0 auto;

  padding: 7px 11px;

  font-family: var(--font-1);
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;

  color: var(--pewter);
  background: var(--heavy-metal);
  border: 1px solid var(--outer-space);
  border-radius: 8px;
}

/* Grid */

.categories-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
}

/* Category card */

.category-card {
  position: relative;
  min-width: 0;

  background: var(--bunker-86);
  border: 1px solid var(--outer-space);
  border-radius: 9px;

  overflow: hidden;
  cursor: pointer;

  box-shadow: 5px 5px 0 #0c0f13;

  transition: transform 0.25s ease, border-color 0.25s ease,
    box-shadow 0.25s ease;

  @media (any-hover: hover) {
    &:hover {
      border-color: rgba(33, 193, 126, 0.4);
      transform: translateY(-3px);
      box-shadow: 7px 7px 0 #0c0f13;

      .category-card__image {
        transform: scale(1.055);
      }

      .category-card__overlay {
        opacity: 0.3;
      }
    }
  }
}

.category-card__preview {
  position: relative;
  aspect-ratio: 1 / 1;

  display: flex;
  align-items: center;
  justify-content: center;

  background: radial-gradient(circle at center, #1d2723 10%, #121815 72%);

  border-bottom: 1px solid var(--outer-space);

  overflow: hidden;

  box-shadow: inset 3px 3px 0 rgba(0, 0, 0, 0.42),
    inset -3px -3px 0 rgba(255, 255, 255, 0.035);
}

.category-card__image {
  display: block;
  width: 100%;
  height: 100%;

  object-fit: cover;
  object-position: center;

  transition: transform 0.35s ease;
}

.category-card__placeholder {
  width: 66px;
  height: 66px;
  display: flex;
  align-items: center;
  justify-content: center;

  color: var(--44);
  background: var(--heavy-metal);
  border: 1px solid var(--outer-space);
  border-radius: 10px;

  svg {
    width: 34px;
    height: 34px;
  }
}

.back-page {
  min-width: 44px;
  height: 44px;
}

.category-card__overlay {
  position: absolute;
  inset: 0;

  background: linear-gradient(
    180deg,
    rgba(10, 14, 17, 0.03) 25%,
    rgba(10, 14, 17, 0.64) 100%
  );

  pointer-events: none;
  transition: opacity 0.3s ease;
}

.category-card__badge {
  position: absolute;
  top: 14px;
  left: 14px;
  z-index: 2;

  padding: 7px 9px;

  font-family: var(--font-3);
  font-size: 8px;
  font-weight: 700;
  line-height: 11px;
  letter-spacing: 0.04em;

  color: var(--racing-green);
  background: linear-gradient(142deg, var(--44) 0%, var(--31) 100%);

  border-radius: 6px;

  box-shadow: inset 0 -3px 0 rgba(0, 0, 0, 0.25),
    inset 0 2px 0 rgba(255, 255, 255, 0.2);
}

.category-card__content {
  display: flex;
  flex-direction: column;
  min-height: 190px;
  padding: 20px;
}

.category-card__text {
  flex: 1;
}

.category-card__title {
  margin: 0;

  font-family: var(--font-2);
  font-size: 19px;
  font-weight: 700;
  line-height: 25px;

  color: var(--gray-nurse);
}

.category-card__description {
  display: -webkit-box;
  margin: 9px 0 0;

  font-family: var(--font-1);
  font-size: 13px;
  font-weight: 400;
  line-height: 20px;

  color: var(--pewter);

  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.category-card__button {
  width: 100%;
  min-height: 43px;
  justify-content: center;

  margin: 22px 0 0;
  padding: 11px 14px;

  font-family: var(--font-3);
  font-size: 9px;
  font-weight: 700;
  line-height: 13px;

  svg {
    flex: 0 0 auto;
  }
}

/* Empty state */

.categories-empty {
  display: flex;
  align-items: center;
  flex-direction: column;

  padding: 64px 24px;

  text-align: center;

  background: var(--bunker-86);
  border: 1px solid var(--outer-space);
  border-radius: 10px;

  box-shadow: inset 3px 3px 0 rgba(255, 255, 255, 0.025),
    inset -3px -3px 0 rgba(0, 0, 0, 0.22);
}

.categories-empty__icon {
  width: 72px;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: center;

  color: var(--44);
  background: var(--heavy-metal);
  border: 1px solid var(--outer-space);
  border-radius: 10px;

  svg {
    width: 36px;
    height: 36px;
  }
}

.categories-empty__title {
  margin: 22px 0 0;

  font-family: var(--font-2);
  font-size: 22px;
  font-weight: 700;
  line-height: 29px;

  color: var(--gray-nurse);
}

.categories-empty__description {
  max-width: 470px;
  margin: 10px 0 0;

  font-family: var(--font-1);
  font-size: 14px;
  line-height: 22px;

  color: var(--pewter);
}

/* Transition */

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(7px);
}

/* Responsive */

@media (max-width: 1100px) {
  .categories-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 767.98px) {
  .categories-hero {
    padding: 25px 16px 16px;

    .wrapper {
      padding: 0;
    }
  }

  .categories-hero .wrapper-top {
    align-items: flex-start;
    flex-direction: column;
  }

  .back-title {
    font-size: 25px;
    line-height: 32px;
  }

  .tip {
    width: 100%;
    justify-content: flex-start;
    border-radius: 9px;

    .desc {
      font-size: 12px;
      line-height: 17px;
    }
  }

  .categories-navigation {
    margin-top: 20px;
    padding-bottom: 18px;
  }

  .categories-navigation__list {
    flex-wrap: nowrap;
    margin: 0 -16px;
    padding: 0 16px 4px;

    overflow-x: auto;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .categories-navigation__button {
    flex: 0 0 auto;
    min-height: 40px;
    padding: 10px 16px;
    font-size: 13px;
  }

  .categories-section {
    padding: 8px 16px 70px;

    .wrapper {
      padding: 18px 0 0;
    }
  }

  .categories-section__header {
    align-items: flex-start;
    flex-direction: column;
    gap: 14px;
    margin-bottom: 20px;
  }

  .categories-section__title {
    font-size: 23px;
    line-height: 30px;
  }

  .categories-section__description {
    font-size: 13px;
    line-height: 20px;
  }

  .categories-grid {
    gap: 16px;
  }

  .category-card__content {
    min-height: 180px;
    padding: 17px;
  }

  .category-card__title {
    font-size: 17px;
    line-height: 23px;
  }

  .category-card__button {
    margin-top: 18px;
  }
}

@media (max-width: 619.98px) {
  .categories-grid {
    grid-template-columns: 1fr;
  }

  .category-card__preview {
    aspect-ratio: 16 / 9;
  }

  .category-card__content {
    min-height: auto;
  }

  .categories-section__count {
    display: none;
  }
}

@media (max-width: 420px) {
  .categories-hero .title-container {
    gap: 12px;
  }

  .back-title {
    font-size: 22px;
    line-height: 29px;
  }

  .category-card__badge {
    top: 11px;
    left: 11px;
  }

  .categories-empty {
    padding: 48px 18px;
  }
}
</style>
